import React, { Fragment } from 'react';
import { Route, Routes } from 'react-router-dom';
import { routes } from './routes';
import Layout from '../layout';

const LayoutRoutes = ({ accessPages }) => {
  const accessPagesName = accessPages.map((item) => item.name);
  return (
    <Fragment>
      <Routes>
        {routes.map(({ path, Component, name }, i) => (
          <Route element={<Layout />} key={i}>
            <Route
              path={path}
              element={
                accessPagesName.includes(name) ? (
                  Component
                ) : (
                  <h1>You do no have permission to access this page</h1>
                )
              }
            />
          </Route>
        ))}
      </Routes>
    </Fragment>
  );
};

export default LayoutRoutes;
